module.exports = __webpack_public_path__ + "img/beacon.9127dd3f.png";